import React, { useEffect, useState } from "react";
import { PinturaEditor } from "@pqina/react-pintura";
import {
    createDefaultImageReader,
    createDefaultImageWriter,
    getEditorDefaults,
} from "@pqina/pintura";
import "@pqina/pintura/pintura.css";

const editorDefaults = {
    imageReader: createDefaultImageReader(),
    imageWriter: createDefaultImageWriter(),
    cropMinImageWidth: 100,
    cropMinImageHeight: 25,
    cropEnableInfoIndicator: true,
    utils: ["crop", "resize", "redact"],
};

/**
 * Client-side Pintura editor wrapper (same defaults as network/provider crop flows).
 */
const DynamicPinturaEditor = (props) => {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        return () => {
            if (props.file && props.file instanceof File) {
                URL.revokeObjectURL(props.file);
            }
        };
    }, [props.file]);

    if (!isClient) {
        return <div>Loading editor...</div>;
    }

    return (
        <PinturaEditor
            {...getEditorDefaults()}
            {...editorDefaults}
            {...props}
            className={`pintura-editor ${props.className || ""}`}
            onLoad={(result) => {
                if (props.onLoad) {
                    props.onLoad(result);
                }
            }}
            onLoaderror={(error) => {
                if (props.onLoaderror) {
                    props.onLoaderror(error);
                }
            }}
        />
    );
};

export default DynamicPinturaEditor;
